import React from "react"
import { connect } from "react-redux"
import { values } from "lodash"

import { push } from "connected-react-router"
import CoolPage from "../components/CoolPage"


import {products} from "../../../../data"

import "./Menu.less"

class Menu extends React.PureComponent {
  render() {
    console.log("this is menu.jsx")
    const product = products[this.props.match.params.product_id] || products[encodeURIComponent(this.props.match.params.product_id)]
    
    return (
      <CoolPage
        containerProps={{  }}
        title={"美食"}
        barColor={[255, 255, 255]}
        fixedBar
        className="menuShowPage"
        footerButton
        footerLabel="预定餐位"
        onFooterClick={() => {
          this.props.push(`/catalogo/reservation/selections/${product._id}`)
        }}
      >
        <div className="title">{"全部分类"}</div>
        <div>
          {
            values(product.menus).map(row => (
              <div
                key={row.id}
                style={{backgroundImage: `url(${row.background.image})`}}
                className="menuBox"
                onClick={() => {
                  this.props.push(`/catalogo/menuContent/${product._id}/${row.id}`)
                }}
              >
                <div className="cover">
                  <p className="menuName">{row.chName}</p>
                  <div className="tags">
                    <div className="price">
                      {row.price}
                        欧/人
                    </div>
                  </div>
                </div>  
              </div>
            ))
          }
        </div>
      </CoolPage>
    )
  }
}

const mapStateToProps = () => {
 
}
const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url))
})


export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/app/catalogo/products/Menu.jsx